export default __webpack_public_path__ + "static/media/icon-facebook.0db1c477.svg";